<template>
  <div class="flex flex-col" :style="styles">
    <WebviewNavbar v-if="webviewStore.isActive"> Upgrade to Pro </WebviewNavbar>
    <BasicNavbar v-else />

    <div
      ref="container"
      class="overflow-auto px-4 pt-[30px]"
      :style="containerStyles"
    >
      <RouterView />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useUserStore } from '@/shared/stores/user'
import { UserPermission } from '@/shared/graphql/legacy/generated'
import { useRouter } from 'vue-router'
import { useWebviewStore } from '@/shared/stores/webview'
import { useDevice } from '@/shared/composables/useDevice'
import { useAvailableHeight } from '@/shared/composables/useAvailableHeight'
import WebviewNavbar from '@/shared/components/WebviewNavbar.vue'
import BasicNavbar from '@/shared/components/BasicNavbar.vue'

const device = useDevice()
const { availableHeight } = useAvailableHeight()
const router = useRouter()
const userStore = useUserStore()
const webviewStore = useWebviewStore()

const container = ref<HTMLElement>()

const user = computed(() => userStore.user)

watch(user, () => {
  if (user.value?.permissions.includes(UserPermission.Pro)) {
    router.push('/home')
  }
})

const styles = computed(() => ({
  ...(webviewStore.isActive && {
    paddingTop: `${webviewStore.topSafeAreaHeight}px`,
    height: `${device.viewportHeight.value}px`,
  }),
}))

const containerStyles = computed(() => ({
  ...(!webviewStore.isActive && {
    height: `${availableHeight.value}px`,
    paddingBottom: '12px',
  }),
}))

onMounted(() => {
  if (!webviewStore.isActive) return
  container.value?.addEventListener('scroll', webviewStore.handleScroll)
})

onBeforeUnmount(() => {
  container.value?.removeEventListener('scroll', webviewStore.handleScroll)
})
</script>
